import { PointInfo } from "../../WalltoFittingInfo";
import { WallGrid } from "../WallGrid";

/**
 * 部屋囲みを見て、直線になっていないところは直線にする
 * */
export class StraightLine extends WallGrid {

    constructor(public pointList: PointInfo[], private roomList: number[][]) {
        super(pointList);
    }

    public execute(): PointInfo[] {

        this.roomList.forEach((room: number[]) => {
            room.forEach((index: number, i: number, array: number[]) => {
                const p1 = this.pointList[index].point;
                const p2 = this.pointList[array[(i + 1) % array.length]].point;
                const p3 = this.pointList[array[(i + 2) % array.length]].point;

                /** 80度から90度までは除外 */
                const sin = p1.clone().sub(p2).clone().normalize().cross(p3.clone().sub(p2).clone().normalize()).y;
                if ((0.9848 <= sin && sin <= 1) || (-1 <= sin && sin <= -0.9848)) return;
                
                const dir = p2.clone().sub(p1);
                const next = p3.clone().sub(p1);
                const length = dir.clone().dot(next) / (next.length());
                /** 垂直に下したときの線が線分上になかったら除外 */
                if (next.length() < length || length < 0) return;

                const line = dir.clone().cross(next).divideScalar(next.length());
                /** 直線化 */
                if (line.length() < this.e) {
                    const point = next.clone().normalize().multiplyScalar(length).clone().add(p1);
                    const index_ = array[(i + 1) % array.length];
                    this.pointList[index_].point.set(point.x, point.y, point.z);
                    const gridList = this.indexToGridList[index_];
                    this.clockwiseData[gridList].forEach((p: number) => {
                        this.pointList[p].point.set(point.x, point.y, point.z);
                    });
                }
            });
        });

        return this.pointList;

    }

    public length(e: number) {
        this.e = e / 1000; /** 単位 mm → m */
    }

}